// src/components/molecules/SelectionToggle/SelectionToggle.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Badge, Tooltip } from '@mui/material';
import {
  CheckBox as CheckBoxIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import {
  operationalRadii,
  operationalSizing,
  operationalSpacing
} from '../../../design-system/tokens';

/**
 * SelectionToggle - Componente molecular para botão de modo de seleção
 *
 * CLASSIFICAÇÃO: MOLÉCULA
 *
 * Este componente combina Button + Badge + Icons para criar um toggle
 * de modo de seleção com contador de itens selecionados.
 *
 * @see https://bradfrost.com/blog/post/atomic-web-design/
 */
const SelectionToggle = ({
  active,
  onClick,
  selectedCount = 0,
  className = '',
  ...props
}) => {


  return (
    <Tooltip title={active ? 'Cancelar seleção' : 'Selecionar'} arrow>
      <Badge
        badgeContent={selectedCount}
        color="primary"
        invisible={selectedCount === 0 || !active}
      >
        <Button
          variant={active ? 'contained' : 'outlined'}
          color={active ? 'secondary' : 'primary'}
          onClick={onClick}
          className={`selection-toggle ${className}`}
          sx={{
            // Usando Design Tokens para consistência
            minWidth: operationalSizing.compact,
            width: operationalSizing.compact,
            height: operationalSizing.compact,
            p: operationalSpacing.xs,
            borderRadius: `${operationalRadii.control}px`,
            ...props.sx
          }}
          {...props}
        >
          {active ? <CloseIcon sx={{ fontSize: '1.3rem' }} /> : <CheckBoxIcon sx={{ fontSize: '1.3rem' }} />}
        </Button>
      </Badge>
    </Tooltip>
  );
};

SelectionToggle.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  selectedCount: PropTypes.number,
  className: PropTypes.string
};

export default SelectionToggle;
